(function () {
  angular.module('MktzapApp.Controllers')
    .controller('TrackNotificationController', trackNotificationController);

  trackNotificationController.$inject = ['$scope', 'FoundationApi', 'ngTableParams', 'TrackNotificationService', 'NotificationService', '$rootScope'];

  function trackNotificationController ($scope, FoundationApi, ngTableParams, TrackNotificationService, NotificationService, $rootScope) {
    var vm = this;
    vm.script = '';
    vm.show = show;
    vm.searchTrackNotificationTable = searchTrackNotificationTable;
    vm.search = false;
    vm.titleEmail = 'Email';
    vm.titlePhone = 'Phone';
    vm.titleContract = 'Contract';
    vm.titleDelivered = 'Delivered';
    vm.titleType = 'Type';
    vm.titleProduct = 'Product';
    vm.titleTrackingNumber = 'Tracking Number';
    vm.titleEmbossingDate = 'Embossing Date';
    vm.titleData = 'Data (JSON)';
    vm.totalTrackNotification = 0;

    vm.filters = {
      phone: '',
      email: ''
    }

    function searchTrackNotificationTable () {
      vm.trackNotificationTable = new ngTableParams({
        count: 50
      }, {
        counts: [25, 50, 100],
        getData: function ($defer, params) {
          var obj = params.url();

          var keys = Object.keys(vm.filters);
          for (var i = 0; i < keys.length; i++) {
            var filterValue = vm.filters[keys[i]];
            if (filterValue != null && filterValue !== '') {
              obj['filter[' + keys[i] + ']'] = filterValue;
            }
          }

          TrackNotificationService
            .getTrackNotification(obj)
            .$promise
            .then(function (data) {
              vm.search = true;
              $defer.resolve(data.tracknotification);

              if (data.success) {
                vm.totalTrackNotification = data.tracknotification.length;
              } else {
                vm.search = false;
                NotificationService.errorHandler(data, data.message);
                vm.totalTrackNotification = 0;
              }
            }).catch(function (data) {
              vm.search = false;
              NotificationService.errorHandler(data, 'Erro ao carregar as trackNotifications!');
              vm.totalTrackNotification = 0;
            });
        }
      });
    }

    $scope.updateTrackNotificationObject = function () {
      if (vm.script !== '') {
        try {
          $scope.message = JSON.parse(vm.script);
          $scope.formatting = { color: 'green', 'background-color': '#d0e9c6' };
          vm.trackNotificationValid = true;
        } catch (e) {
          $scope.formatting = { color: 'red', 'background-color': '#f2dede' };
          vm.trackNotificationValid = false;
        }
      } else {
        $scope.formatting = {};
      }
    };

    function show (trackNotification) {
      vm.backupDialog = false;
      vm.script = JSON.stringify(trackNotification, null, 2);
      $scope.updateTrackNotificationObject();

      FoundationApi.publish('trackNotificationModal', 'open');
    }
  }
})();
